<div class="p-3">
    <div class="formgrid grid">
        <div class="col-4">
            <p-button icon="pi pi-arrow-left" label="Back" styleClass="p-button-primary" class="flex justify-content-center" (onClick)="goToIncidents()"></p-button>
        </div>
        <div class="col-4">
            <p-button icon="pi pi-comment" label="Note" styleClass="p-button-warning" class="flex justify-content-center" (onClick)="addNote()"></p-button>
        </div>
        <div class="col-4">
            <p-button [disabled]="incident?.goFMXTicketCreated || disableGoFMX" icon="pi pi-wrench" label="GoFMX" styleClass="p-button-help" class="flex justify-content-center" (onClick)="createGoFMX()"></p-button>
        </div>
    </div>
</div>

<div class="grid text-sm p-component">
    <div class="col-1 font-bold">
        <div *ngIf="incident?.ticket?.status != undefined">
            <i [ngClass]="setIncidentIconClass(incident?.ticket?.status)"></i>
        </div>
        <div *ngIf="hasNotes(incident)">
            <i [ngClass]="setIncidentIconClass('Note')"></i>
        </div>
        <div *ngIf="hasAttachments(incident)">
            <i [ngClass]="setIncidentIconClass('Attachment')"></i>
        </div>
    </div>
    <div class="col-11">
        <div class="formgrid grid">
            <div class="col-4 font-bold">
                {{incident.incidentId}}
            </div>
            <div class="col-7 text-right text-xs">
                {{incident.dateCreated | date: "EEE, MM/dd/yy hh:mm a"}}
            </div>
            <div class="col-12 font-bold">
                {{incident.instrumentName}}
            </div>
            <div class="col-12">
                {{incident.userName}}
            </div>
            <div class="col-12 font-medium">
                <div [innerHTML]="incident.htmlSubject | safe:'html'" (click)="processLinks($event)"></div>
            </div>
            <div class="col-12">
                <div [innerHTML]="incident.htmlDescription | safe:'html'" (click)="processLinks($event)"></div>
            </div>
        </div>
    </div>
    <div *ngIf="hasNotes(incident)">
        <div *ngFor="let note of notes; index as i" class="p-1 formgrid grid">
            <div class="col-12">
                <div class="p-1 border-round border-2 border-yellow-400">
                    <div class="formgrid grid">
                        <div class="col-5 font-bold">
                            {{note.by?.name}}
                        </div>
                        <div class="col-6 col-offset-1 text-right text-sm">
                            {{note.timestamp | date: "EEE, MM/dd/yy hh:mm a"}}
                        </div>
                        <div class="col-12">
                            <div [innerHTML]="note.htmlText | safe:'html'" (click)="processLinks($event)"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngFor="let attachment of note.attachments" class="p-1">
                <div class="col-12">
                    <div class="p-1 border-round border-2 border-bluegray-400">
                        <div class="formgrid grid">
                            <div class="col-12">
                                <img [src]="attachment.url" class="max-w-full">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-dialog header="New Note" [(visible)]="newNoteModal" [breakpoints]="{ '960px': '75vw' }" [style]="{ width: '90vw' }" [draggable]="false" [resizable]="false">
    <div class="grid p-fluid flex flex-wrap">
        <div class="col-12">
            <label for="summary">Summary</label>
            <textarea id="summary" rows="5" cols="30" pInputTextarea [(ngModel)]="summary"></textarea>
        </div>
        <div class="col-12">
            <label for="attachment">Attach a photo</label>

            <input id="attachment" type="file" accept="image/*;capture" 
                (change)="handleFileInput($event)" multiple/>
        </div>
        <div *ngFor="let filePreview of filePreviews">
            <div class="col-12">
                <img [src]="filePreview | safe:'url'" class="max-w-full">
            </div>
        </div>
        
        <div class="col-6">
            <p-button label="Cancel" styleClass="p-button-secondary" class="flex justify-content-center" (onClick)="closeNoteModal()"></p-button>
        </div>
        <div class="col-6">
            <p-button [loading]="submitWait" [disabled]="!saveEnabled" icon="pi pi-save" label="Save" styleClass="p-button-primary" class="flex justify-content-center" (onClick)="saveNote()"></p-button>
        </div>
    </div>
</p-dialog>
